// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__PeqFO","tooltipTitle":"Tooltip_tooltipTitle__vEQLq","tooltipText":"Tooltip_tooltipText__y-C4K"};